import styles from "./Hint.module.css";
import { PropsWithChildren } from "react";
import classNames from "classnames";
import heartIcon from "../../assets/icons/heart.svg";

type HintProps = {
  variant?: "default" | "centered" | "highlighted" | "positive";
};

export const Hint = (props: PropsWithChildren<HintProps>) => {
  const { variant = "default", children } = props;

  const hintClassNames = classNames(styles.hint, { [styles[variant]]: variant !== "default" });

  return (
    <p className={hintClassNames}>
      {variant === "positive" ? <img src={heartIcon} alt="" className={styles.icon} /> : null}
      {children}
    </p>
  );
};
